import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboards-filter" }
const _hoisted_2 = { class: "dashboards-filter__header" }
const _hoisted_3 = { class: "dashboards-filter__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectMultiComponentDashed = _resolveComponent("SelectMultiComponentDashed")!
  const _component_DashboardsYearFilterBlock = _resolveComponent("DashboardsYearFilterBlock")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SelectMultiComponentDashed, {
        modelValue: _ctx.getSelectFilterValue,
        "onUpdate:modelValue": _ctx.changeSelectFilter,
        options: _ctx.selectConfig.options,
        title: _ctx.selectConfig.title,
        class: "dashboards-filter__select"
      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "title"]),
      _renderSlot(_ctx.$slots, "controls", {}, () => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isShowYearFilter)
            ? (_openBlock(), _createBlock(_component_DashboardsYearFilterBlock, {
                key: 0,
                onChangeFilter: _ctx.changeFilter,
                filter: _ctx.getBaseFilter
              }, null, 8, ["onChangeFilter", "filter"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "export-buttons", {}, () => [
            _createVNode(_component_ExportButtons, {
              class: "dashboards-filter__export-buttons",
              loading: _ctx.isExportProgress,
              onExportPdf: _ctx.downloadPDF,
              onExportPptx: _ctx.downloadPptx,
              exportTypes: ['pptx', 'pdf']
            }, null, 8, ["loading", "onExportPdf", "onExportPptx"])
          ], true)
        ])
      ], true)
    ])
  ]))
}